import * as t from "@babel/types";
import { MODULE_SOURCE } from "./constants.js";
export function validateFunction(fn, state) {
  if (fn.async || fn.generator) {
    state.errors.push({
      message: "Function cannot be async or generator",
      node: fn,
      severity: "error"
    });
    return false;
  }
  return true;
}
export function validateGlobalApi(id, api) {
  var ref = id.referencesImport(MODULE_SOURCE, api);
  if (ref) {
    return true;
  }
  return id.node.name === api && !id.scope.getBinding(id.node.name);
}
export function validateEmbeddedExpression(expr, state) {
  var invalidNode = null;
  t.traverse(expr, {
    enter: function enter(node, parent) {
      var _parent;
      if (!invalidNode && (t.isFunctionExpression(node) || t.isStatement(node) || t.isAwaitExpression(node) || t.isYieldExpression(node) || t.isJSX(node) || t.isArrowFunctionExpression(node) && (node.async || node.generator || t.isBlockStatement(node.body) || t.isObjectProperty((_parent = parent[parent.length - 1]) === null || _parent === void 0 ? void 0 : _parent.node)))) {
        invalidNode = node;
      }
    }
  });
  if (invalidNode) {
    state === null || state === void 0 || state.errors.push({
      message: "Unsupported expression type: ".concat(invalidNode.type),
      node: invalidNode,
      severity: "error"
    });
    return false;
  }
  return true;
}
export function isNilPath(path) {
  return path.isNullLiteral() || path.isIdentifier() && path.node.name === "undefined" && path.scope.getBinding("undefined") === undefined;
}
var EXPRESSION_PREFIX_REG = /^<%=?\s/;
var EXPRESSION_SUFFIX_REG = /\s%>$/;
export function isExpressionString(value) {
  if (typeof value !== "string") {
    return false;
  }
  var trimmed = value.trim();
  return EXPRESSION_PREFIX_REG.test(trimmed) && EXPRESSION_SUFFIX_REG.test(trimmed);
}
export function isAnyOfficialComponent(child) {
  return !child.reference || child.reference.type === "imported" && child.reference.importSource === MODULE_SOURCE;
}
export function isOfficialComponent(child, name) {
  return isAnyOfficialComponent(child) && (child.reference ? child.reference.name === name : child.name === name);
}
export function isGeneralCallExpression(path) {
  return path.isCallExpression() || path.isOptionalCallExpression();
}
export function isGeneralMemberExpression(path) {
  return path.isMemberExpression() || path.isOptionalMemberExpression();
}
export function isGeneralFunctionExpression(path) {
  return path.isFunctionExpression() || path.isArrowFunctionExpression();
}
//# sourceMappingURL=validations.js.map